module.exports = __webpack_public_path__ + "img/2025-11-17c_4.151203da.jpg";